import React, { useState, useEffect} from 'react';
import './HomeScreen.css'

//fix items on the cart from shrinking and wrapping their contents;

//search how to handle payment in react apps;

//add a bubble nav component to the top of each shop page that moves like a display bar // bill board to show off new products and offer their links when clicked on so that page feels like it has life

//Components

//mobile images
import MainImg1 from '../../images/mobile-image-hero-1.jpg';
import MainImg2 from '../../images/mobile-image-hero-2.jpg';
import MainImg3 from '../../images/mobile-image-hero-3.jpg';
import SecondaryImg from '../../images/image-about-dark.jpg';
import ThirdImg from '../../images/image-about-light.jpg';

//desktop
import MainDesktopImg1 from '../../images/desktop-image-hero-1.jpg';
import MainDesktopImg2 from '../../images/desktop-image-hero-2.jpg';
import MainDesktopImg3 from '../../images/desktop-image-hero-3.jpg';
import { useHistory } from 'react-router';


function HomeScreen() {

    const history = useHistory()

    const windowWidth = window.screen.width
    
    // const windowHeight = window.screen.height;
    // console.log(windowWidth, windowHeight);

    const [carousel, setCarousel] = useState(0);

    const [showLinks, setShowLinks] = useState(null);

    const [showShopLinks, setShowShopLinks] = useState(null);
    // console.log(carousel);
    // console.log(showShopLinks);

    useEffect(() => {
        let mounted = true;
            setInterval(() => {
                    if (mounted) {
                    setCarousel(prevVal => {
                    if (prevVal === 2) return 0
                    else return prevVal + 1
                    });
                }
            }, 20000)
        // console.log('re-render cycle');
        return () => {
            mounted = false;
        }
    },[])

    return (
        <div className="homeScreen">

                <div className='homeScreen__top__half'>

                    <div className="homeScreen__main__img fadein" 

                        style={{backgroundSize:'cover',
                        backgroundImage: `url(${carousel === 0 && windowWidth < 800 ? MainImg1 
                        : carousel === 1 && windowWidth < 800 ? MainImg2 
                        : carousel === 2 && windowWidth < 800 ? MainImg3 
                        : carousel === 0 && windowWidth > 800 ? MainDesktopImg1
                        : carousel === 1 && windowWidth > 800 ? MainDesktopImg2
                        : carousel === 2 && windowWidth > 800 ? MainDesktopImg3
                        : MainImg1 })`}} 
                        key={carousel}>

                        <div className={`${showLinks && windowWidth < 800 ? 'homeScreen__backDrop' : ''} `}>
                        </div>
                        <div className='homeScreen__bar__flex'>
                                <div className={`hamburger burger__icon ${showLinks ? 'is-active move__left' : null}`} id="hamburger-1" onClick={() => {
                                    if (showLinks) {
                                        setShowLinks(false);
                                        setShowShopLinks(false);
                                    } else setShowLinks(true)
                                    
                                }}>
                                    <span className={`line`} style={{backgroundColor: `${showLinks ? 'lightgrey' : ''}`}}></span>
                                    <span className={`line`} style={{backgroundColor: `${showLinks ? 'lightgrey' : ''}`}}></span>
                                    <span className={`line`} style={{backgroundColor: `${showLinks ? 'lightgrey' : ''}`}}></span>
                                </div>

                                <div className={`homeScreen__links ${showLinks ? 'show__links fadein' : null}`}>
                                    <p className='hover-underline-animation' onClick={() => history.push('/')}>Home</p>
                                    <p className='hover-underline-animation' onClick={() => showLinks || windowWidth > 800 ? showShopLinks ? setShowShopLinks(false) : setShowShopLinks(true) : null}>Shop <svg
                                        className={`arrow__svg__shop ${showShopLinks ? 'open__shopDownLinks' : 'close__shopDownLinks'}`} width="15" height="12" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg></p>
                                    <div className={`shopDownLinks ${showShopLinks  ? 'slide__down__div' : null}`}>
                                        <p className='nav__home__underline' onClick={() => showShopLinks ? history.push('/shop/chairs') : null}>Chairs</p>
                                        <p className='nav__home__underline' onClick={() => showShopLinks ? history.push('/shop/tables') : null}>Tables</p>
                                        <p className='nav__home__underline' onClick={() => showShopLinks ? history.push('/shop/cabinets') : null}>Cabinets</p>
                                        <p className='nav__home__underline' onClick={() => showShopLinks ? history.push('/shop/room_decor') : null}>Room Decor</p>
                                        <p className='nav__home__underline' onClick={() => showShopLinks ? history.push('/shop') : null}>All</p>

                                    </div>
                                    <p className='hover-underline-animation' onClick={() => showLinks || windowWidth > 800 ? history.push('/about') : null }>About</p>
                                    <p className='hover-underline-animation' onClick={() => showLinks || windowWidth > 800 ? history.push('/contact') : null}>Contact</p>
                                    <p> </p>
                                </div>
                                
                                <svg onClick={() => history.push('/')} width="62" className='logo__svg' height="14"><path d="M2.988 12.672v-7.32c0-.48.142-.928.426-1.344a3.36 3.36 0 011.11-1.02c.456-.264.94-.396 1.452-.396.296 0 .618.048.966.144.348.096.654.224.918.384L9.096.588A4.277 4.277 0 007.998.162 5.115 5.115 0 006.744 0c-.776 0-1.488.186-2.136.558-.648.372-1.188.91-1.62 1.614V.384H0v12.288h2.988zm13.472.384c1.328 0 2.526-.276 3.594-.828a6.406 6.406 0 002.532-2.304c.62-.984.93-2.116.93-3.396 0-1.288-.31-2.422-.93-3.402A6.421 6.421 0 0020.054.828C18.986.276 17.788 0 16.46 0c-1.336 0-2.536.276-3.6.828a6.476 6.476 0 00-2.532 2.298c-.624.98-.936 2.114-.936 3.402 0 1.28.312 2.412.936 3.396a6.45 6.45 0 002.538 2.304c1.068.552 2.266.828 3.594.828zm0-2.568c-.744 0-1.416-.17-2.016-.51a3.729 3.729 0 01-1.416-1.404c-.344-.596-.516-1.278-.516-2.046 0-.776.172-1.462.516-2.058a3.686 3.686 0 011.416-1.398c.6-.336 1.272-.504 2.016-.504.752 0 1.426.168 2.022.504a3.698 3.698 0 011.41 1.398c.344.596.516 1.282.516 2.058 0 .768-.172 1.45-.516 2.046a3.741 3.741 0 01-1.41 1.404c-.596.34-1.27.51-2.022.51zm15.704 2.568c1.328 0 2.526-.276 3.594-.828a6.406 6.406 0 002.532-2.304c.62-.984.93-2.116.93-3.396 0-1.288-.31-2.422-.93-3.402A6.421 6.421 0 0035.758.828C34.69.276 33.492 0 32.164 0c-1.336 0-2.536.276-3.6.828a6.476 6.476 0 00-2.532 2.298c-.624.98-.936 2.114-.936 3.402 0 1.28.312 2.412.936 3.396a6.45 6.45 0 002.538 2.304c1.068.552 2.266.828 3.594.828zm0-2.568c-.744 0-1.416-.17-2.016-.51a3.729 3.729 0 01-1.416-1.404c-.344-.596-.516-1.278-.516-2.046 0-.776.172-1.462.516-2.058a3.686 3.686 0 011.416-1.398c.6-.336 1.272-.504 2.016-.504.752 0 1.426.168 2.022.504a3.698 3.698 0 011.41 1.398c.344.596.516 1.282.516 2.058 0 .768-.172 1.45-.516 2.046a3.741 3.741 0 01-1.41 1.404c-.596.34-1.27.51-2.022.51zm12.608 2.184V4.896c0-.44.126-.85.378-1.23s.596-.686 1.032-.918c.436-.232.93-.348 1.482-.348.8 0 1.432.258 1.896.774.464.516.696 1.206.696 2.07v7.428h2.988V4.908c0-.44.124-.852.372-1.236a2.717 2.717 0 011.02-.924c.432-.232.92-.348 1.464-.348.8 0 1.438.266 1.914.798s.714 1.254.714 2.166v7.308h2.988V4.548c0-.952-.198-1.766-.594-2.442a4.051 4.051 0 00-1.62-1.56C58.818.182 58.036 0 57.156 0c-.928 0-1.744.21-2.448.63-.704.42-1.332 1.022-1.884 1.806-.312-.744-.846-1.336-1.602-1.776C50.466.22 49.604 0 48.636 0c-.752 0-1.442.152-2.07.456-.628.304-1.226.772-1.794 1.404V.384h-2.988v12.288h2.988z" fill="#FFF" fillRule="nonzero"/></svg>
                        </div>
                        <div className='slider__btn__container'>

                            <div tabIndex='1' className='slider__left' onKeyUp={(e) => {
                                if (e.keyCode === 13) setCarousel(prevVal => {
                                    if (prevVal === 0) return 2;
                                    else return prevVal - 1;
                                })
                            }} onClick={() => {
                                setCarousel(prevVal => {
                                    if (prevVal === 0) return 2;
                                    else return prevVal - 1;
                                    })}
                                }>
                                <svg width="14" height="24"><path d="M13 0L1 12l12 12" stroke="#FFF" fill="none" fillRule="evenodd"/></svg>
                            </div>

                            <div tabIndex='2' className='slider__right' onKeyUp={(e) => {
                                if (e.keyCode === 13) setCarousel(prevVal => {
                                    if (prevVal === 0) return 2;
                                    else return prevVal - 1;
                                })
                            }} onClick={() => {
                                setCarousel(prevVal => {
                                    if (prevVal === 2) return 0;
                                    else return prevVal + 1;
                                    })}
                                }>
                                <svg width="14" height="24"><path d="M1 0l12 12L1 24" stroke="#FFF" fill="none" fillRule="evenodd"/></svg>
                            </div>
                            
                        </div>


                    </div>

                    <div className='homeScreen__main__blur'>
                        { carousel === 0 ?
                        <div key={carousel} className='complete__fadein'>
                            <h1>Discover innovative ways to decorate</h1>
                            <p className='homeScreen__main__blur__para'>We provide unmatched quality, comfort and style for property owners across the country. Our experts combine form and function in bringing your vision to life. Create a room in your own style with our collection and make your property a reflection of you and what you love.</p>
                            <div className='homeScreen__shopNow__div'>
                                <h2 onClick={() => history.push('/shop')}>SHOP NOW</h2>
                                <svg width="40" height="12" className='svg__arrow__shopNow'><path d="M34.05 0l5.481 5.527h.008v.008L40 6l-.461.465v.063l-.062-.001L34.049 12l-.662-.668 4.765-4.805H0v-1h38.206l-4.82-4.86L34.05 0z" fill="#000" fillRule="nonzero"/></svg>
                            </div>
                        </div>
                        : carousel === 1 ?
                        <div key={carousel} className='complete__fadein'>
                            <h1>We are available all across the globe</h1>
                            <p className='homeScreen__main__blur__para'>With stores all over the world, it's easy for you to find furniture for your home or place of business. Locally, we're in most major cities throughout the country. Find the branch nearest to you using our store locator. Any questions? Don't hesitate to contact us today.</p>
                            <div className='homeScreen__shopNow__div__2'>
                                <div className='redirect__links1'>
                                    <h2 onClick={() => history.push('/about')}>LOCATE US</h2>
                                    <svg width="40" height="12" className='svg__arrow__shopNow'><path d="M34.05 0l5.481 5.527h.008v.008L40 6l-.461.465v.063l-.062-.001L34.049 12l-.662-.668 4.765-4.805H0v-1h38.206l-4.82-4.86L34.05 0z" fill="#000" fillRule="nonzero"/></svg>
                                </div>
                                <div className='redirect__links2'>
                                    <h2 onClick={() => history.push('/contact')}>CONTACT US</h2>
                                    <svg width="40" height="12" className='svg__arrow__shopNow'><path d="M34.05 0l5.481 5.527h.008v.008L40 6l-.461.465v.063l-.062-.001L34.049 12l-.662-.668 4.765-4.805H0v-1h38.206l-4.82-4.86L34.05 0z" fill="#000" fillRule="nonzero"/></svg>
                                </div>
                            </div>
                        </div>
                        : carousel === 2 ? 
                        <div key={carousel} className='complete__fadein'>
                            <h1>Manufactured with the best materials </h1>
                            <p className='homeScreen__main__blur__para'>Our modern furniture stores provide a a high level of quality. Our company has invested in advanced technology to ensure that every product is made as perfect and as consistent as possible. With three decades of experience in this industry, we understand what customers want for their home and office.</p>
                            <div className='homeScreen__shopNow__div'>
                                <h2 onClick={() => history.push('/shop')}>SHOP NOW</h2>
                                <svg width="40" height="12" className='svg__arrow__shopNow'><path d="M34.05 0l5.481 5.527h.008v.008L40 6l-.461.465v.063l-.062-.001L34.049 12l-.662-.668 4.765-4.805H0v-1h38.206l-4.82-4.86L34.05 0z" fill="#000" fillRule="nonzero"/></svg>
                            </div>
                        </div>
                    : null}
                    </div>

                </div>
                <div className='homeScreen__bottom__half'>

                    <div className='homeScreen__secondary__img' style={{objectFit: 'contain', backgroundImage: `url(${SecondaryImg})`, backgroundSize: 'cover', backgroundPosition: 'center bottom'}}>
                    </div>

                    <div className='homeScreen__secondary__blur'>
                        <h1> ABOUT OUR FURNITURE </h1>
                        <p>Our multifunctional collection blends design and function to suit your individual taste. Make each room unique, or pick a cohesive theme that best express your interests and what inspires you. Find the furniture pieces you need, From traditional to contemporary styles or anything in between. Product specialists are available to help you create your dreams space.</p>
                    </div>

                    <div className='homeScreen__third__img' style={{objectFit: 'contain',backgroundImage: `url(${ThirdImg})`, backgroundSize: 'cover', backgroundPosition: 'center bottom'}}>
                    </div>

                </div>

        </div>
    )
}

export default HomeScreen
